// Mock data for the marketing landing preview.
// Everything here will later be replaced by live API responses.

export const liveStats = {
  members: 0,
  countries: 0,
  checkins: 0,
  coaches: 5,
};

export const pillars = [
  {
    key: "onehome",
    title: "One home",
    body: "Movement, food, sleep, mind and cycle in a single calm space that finally talks to itself — no more twelve disconnected apps.",
  },
  {
    key: "intelligence",
    title: "Knows you",
    body: "Coaches and insights that read your real data and adapt to how you actually feel — day to day, not a rigid template.",
  },
  {
    key: "together",
    title: "Never alone",
    body: "Bring your partner, family and tribe. Shared streaks, gentle accountability and real belonging — wherever you are in the world.",
  },
];

// Approximate positions (in %) over the map panel for animated member dots
export const memberPins = [
  { x: 22, y: 38, city: "New York" },
  { x: 30, y: 62, city: "São Paulo" },
  { x: 47, y: 30, city: "London" },
  { x: 50, y: 40, city: "Lagos" },
  { x: 54, y: 55, city: "Nairobi" },
  { x: 62, y: 34, city: "Dubai" },
  { x: 70, y: 44, city: "Mumbai" },
  { x: 80, y: 38, city: "Tokyo" },
  { x: 85, y: 66, city: "Sydney" },
  { x: 43, y: 26, city: "Paris" },
  { x: 16, y: 46, city: "Los Angeles" },
  { x: 58, y: 24, city: "Berlin" },
];

export const showcase = [
  {
    label: "Your daily home",
    title: "Dashboard",
    desc: "A calm, time-aware home that greets you, tracks your streak and points, and shows exactly what matters today.",
    image: "https://images.unsplash.com/photo-1524863479829-916d8e77f114",
  },
  {
    label: "Coaches that know you",
    title: "AI Coaches",
    desc: "Amara, Jabari, Zuri, Kofi and Lumi — five distinct coaches that read your data and adapt to how you feel, including Lumi for pregnancy, postpartum & cycle care.",
    image: "https://images.unsplash.com/photo-1687436874044-2c593fbf0245",
  },
  {
    label: "Fuel with intention",
    title: "Nutrition",
    desc: "Scan a meal with your camera, track macros effortlessly, and get gentle, human guidance — not guilt.",
    image: "https://images.pexels.com/photos/6648539/pexels-photo-6648539.jpeg",
  },
  {
    label: "The world, together",
    title: "Travel Passport",
    desc: "Collect country stamps, find members near you, and watch a living map of people moving with you.",
    image: "https://images.unsplash.com/photo-1545205597-3d9d02c29597",
  },
];

export const pricing = [
  {
    name: "Free",
    price: "$0",
    period: "",
    tagline: "Start your journey — no card, no pressure.",
    cta: "Start free",
    features: [
      "Basic tracking",
      "Community activity feed",
      "1 daily quest",
    ],
    highlight: false,
  },
  {
    name: "Individual",
    price: "$9.99",
    period: "/mo",
    tagline: "Everything you need to become your best self.",
    cta: "Start 30-day trial",
    features: [
      "Full app — training, nutrition, mind",
      "All 5 AI coaches",
      "Travel passport & global map",
      "Leaderboards, challenges & badges",
    ],
    highlight: false,
  },
  {
    name: "Family",
    price: "$14.99",
    period: "/mo",
    tagline: "You, your partner and your first child — included.",
    cta: "Start 30-day trial",
    features: [
      "Everything in Individual",
      "You + partner + 1 child free",
      "Shared family dashboard",
      "Gentle accountability alerts",
      "Extra children just $2.99/mo each",
    ],
    highlight: true,
  },
  {
    name: "Premium Elite",
    price: "$19.99",
    period: "/mo",
    tagline: "The complete WYVN experience.",
    cta: "Start 30-day trial",
    features: [
      "Everything in Family",
      "Priority AI coaching",
      "Exclusive programs & content",
      "1:1 human check-ins",
      "Early access to new features",
    ],
    highlight: false,
  },
];

export const reviews = [];
